"use strict";

var controllerModule = angular.module("app.controllers", ["ui.bootstrap"]);
controllerModule.controller('navbarCtrl', Patersons.NavbarCtrl); 
controllerModule.controller('footerCtrl', Patersons.FooterCtrl);
controllerModule.controller('abstractController', Patersons.AbstractController);
controllerModule.controller('clientAdviserViewCtrl', Patersons.ClientAdviserViewCtrl);
controllerModule.controller('helpViewCtrl', Patersons.HelpViewCtrl);
controllerModule.controller('landingCtrl', Patersons.LandingCtrl); 
